import React, { useEffect, useRef } from "react";

import "./ListSearchComponent.scss";

import { ReactComponent as SearchIcon } from "../../../../../assets/svg/search.svg";
import { ReactComponent as CloseIcon } from "../../../../../assets/svg/close.svg";

const ListSearchComponent = (props) => {
    const focusInputBar = useRef(null);
    useEffect(() => {
        if (props.focusInput) {
            focusInputBar.current.focus();
        }
    }, []);

    const searchList = (e) => {
        props.updateValue(e.target.value);
    };

    return (
        <div className="list-search-component">
            <span className="search-icon">
                <SearchIcon />
            </span>
            <input
                ref={focusInputBar}
                type="text"
                placeholder={props.placeholder ? props.placeholder : "Search"}
                onChange={(e) => searchList(e)}
                value={props.value}
            />
            <span className="clear-icon">
                {(props.value.length !== 0 || props.showClear) && (
                    <span onClick={() => props.updateValue("")}>
                        <CloseIcon />
                    </span>
                )}
            </span>
        </div>
    );
};

export default ListSearchComponent;
